/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import InstanceField from '@folio/inventory/src/Instance/InstanceEdit/InstanceField/index';
import { Col, Row } from '@folio/stripes-components';
import { useIntl } from 'react-intl';
import { filter } from 'lodash';
import { psTitleRelationshipId } from '@folio/inventory/src/utils';
import HelpeModal from '../../HelpeModal';
import css from '../styles.css';
import useDataByName from '../../../hooks/useDataByName';

const propTypes = {
  fieldValues: PropTypes.object,
  index: PropTypes.number,
  fieldName: PropTypes.string,
  parentField: PropTypes.object,
  showHelpeIcon: PropTypes.bool,
  fields: PropTypes.object,
  controlledVocab: PropTypes.object,
};

function InstanceFieldComponent({
  fieldValues,
  index,
  fieldName,
  parentField,
  showHelpeIcon,
  fields,
  controlledVocab,
}) {
  const { name, label, canEdit } = fieldValues;
  // const dataSource = useDataByName(parentField.dataOptionsSource);
  const dataSource = controlledVocab[parentField.dataOptionsSource];

  const mostParentChildRelationships = filter(
    dataSource,
    (rt) => rt.id !== psTitleRelationshipId(dataSource),
  );
  const relationshipTypes = mostParentChildRelationships.map((it) => ({
    label: it.name,
    value: it.id,
  }));

  const intl = useIntl();
  const fieldLabel = label.find((field) => field.locale === intl.locale)?.value;

  return (
    <Row>
      <Col xs={showHelpeIcon ? 11 : 12}>
        <InstanceField
          field={fieldName.replace(`.${name}`, '')}
          index={index}
          fields={fields}
          isDisabled={!canEdit}
          relationshipTypes={relationshipTypes}
          titleIdKey={
            parentField.name.startsWith('parent')
              ? 'superInstanceId'
              : 'subInstanceId'
          }
        />
      </Col>
      {showHelpeIcon && (
        <Col xs={1} className={css.margin_btn}>
          <HelpeModal
            fieldData={fieldValues}
            title={fieldLabel}
            iconSize="medium"
          />
        </Col>
      )}
    </Row>
  );
}

InstanceFieldComponent.propTypes = propTypes;

export default InstanceFieldComponent;
